<template>
  <v-container bg="b" class="clients-container">
    <v-headline :level="2" class="clients-title uppercase"
      >{{ dic.clientsSection.title }} {{ dic.brand }}</v-headline
    >

    <v-carousel class="clients-carousel" :slides="clients">
      <template v-slot:default="cProps">
        <div class="clients-carousel-container">
          <carousel-nav-button
            v-if="$mq.resize && $mq.above(450)"
            @navclick="cProps.handleNav"
            isRounded
            direction="prev"
            containerTheme="light"
            pointerTheme="dark"
          />

          <carousel-list
            class="clients-list"
            :transitionName="cProps.transitionName"
            :slides="cProps.slides"
            :beforeEnter="cProps.beforeEnter"
            :afterLeave="cProps.afterLeave"
            :currId="cProps.currId"
            @swipe="cProps.handleNav"
            @before-enter="cProps.beforeEnter"
            @after-leave="cProps.afterLeave"
          >
            <template v-slot:default="{ slide }">
              <client-cart :client="slide" />
            </template>
          </carousel-list>

          <carousel-nav-button
            v-if="$mq.resize && $mq.above(450)"
            @navclick="cProps.handleNav"
            isRounded
            direction="next"
            containerTheme="light"
            pointerTheme="dark"
          />
        </div>
        <!--CLIENTS CAROUSEL CONTAINER-->

        <carousel-pagination
          class="clients-pagination"
          :items="cProps.slides"
          :index="cProps.index"
          @pagclick="cProps.handlePag"
        />
      </template>
    </v-carousel>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

import VContainer from '@/components/ui/VContainer'
import VHeadline from '@/components/ui/VHeadline'

import VCarousel from '@/components/carousel/VCarousel'
import CarouselList from '@/components/carousel/CarouselList'

import ClientCart from '@/components/ui/ClientCart'
import CarouselNavButton from '@/components/carousel/CarouselNavButton'
import CarouselPagination from '@/components/carousel/CarouselPagination'

export default {
  name: 'SectionClients',
  components: {
    VHeadline,
    VContainer,
    VCarousel,
    CarouselList,
    ClientCart,
    CarouselNavButton,
    CarouselPagination,
  },
  computed: {
    ...mapState('clients', ['clients']),
    currentLang() {
      //this need for wake up store listner 
      return this.$store.state.main.currentLang
    },
    dic() {
      this.currentLang //this need for wake up store listner 
      return this.$store.state.main.dic
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 375px) {
}

@media (max-width: 411px) {
}

@media (max-width: 768px) {
  .imac {
    display: none;
  }
}
</style>

<style scoped lang="scss">
.clients-container {
  color: #ffffff;
  text-align: center;
}

.clients-title {
  color: white;
  text-align: center;
  display: block;
  padding: 20px;
  width: 70;
}

.clients-carousel {
  padding: 30px 0;
  &-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.clients-list {
  width: 70%;
}
.clients-pagination {
}
</style>

<style lang="scss" scoped>
@media (max-width: 450px) {
  .clients-carousel {
    padding: 0;
  }

  .clients-list {
    width: 100%;
  }
}
</style>
